<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  color?: any
  symbol?: boolean
}>()

const background_color = computed(() => {
  return !props.symbol ? props.color : { color: '#FFFFFF' }
})

const foreground_color = computed(() => {
  return props.symbol ? { color: '#e55a05' } : { color: '#FFFFFF' }
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="background_color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <path
      d="M11.159,33.807c-9.006-3.503-13.466-13.64-9.966-22.647C4.696,2.153,14.837-2.31,23.841,1.196
c9.006,3.498,13.466,13.642,9.966,22.645C30.304,32.849,20.163,37.308,11.159,33.807"
    />
    <rect
      :fill="foreground_color.color"
      x="9.21879"
      y="13.31253"
      width="10.43742"
      height="13.9999"
      rx="1"
    />
    <ellipse
      :fill="background_color.color"
      cx="17.94828"
      cy="22.78121"
      rx="0.8856"
      ry="0.87339"
    />
    <ellipse
      :fill="background_color.color"
      cx="17.94827"
      cy="20.24838"
      rx="0.8856"
      ry="0.87339"
    />
    <ellipse
      :fill="background_color.color"
      cx="17.94828"
      cy="25.31404"
      rx="0.8856"
      ry="0.87339"
    />
    <path
      :fill="foreground_color.color"
      d="m21.25112,8.82622c0.90503,0 1.75597,0.35293 2.3952,0.99318c0.6407,0.64055 0.99295,1.49402 0.99295,
      2.40227l1.39519,0c0,-2.63834 -2.14615,-4.78433 -4.78363,-4.78433l0,1.38888l0.00029,0zm0.00176,
      -2.46261c3.22643,0 5.85067,2.62867 5.85067,5.85952l1.3946,0c0,-3.99675 -3.25024,-7.24869 -7.24557,
      -7.24869l0,1.38917l0.00029,0l0.00001,0zm1.92886,4.8886c0,0.53159 -0.43252,0.96272 -0.9659,0.96272s-0.9659,
      -0.43113 -0.9659,-0.96272c0,-0.53101 0.43252,-0.96214 0.9659,-0.96214s0.9659,0.43084 0.9659,0.96214z"
    />
  </svg>
</template>
